import { render, staticRenderFns } from "./CreateStaffGroupPopUp.vue?vue&type=template&id=15728986&scoped=true&"
import script from "./CreateStaffGroupPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateStaffGroupPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateStaffGroupPopUp.vue?vue&type=style&index=0&id=15728986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15728986",
  null
  
)

export default component.exports